import { observer } from 'mobx-react-lite';
import { EntityPresentationProfile } from 'src/pages/AgentProfilePage/EntityPresentationProfile';
import { AgentProfileStore } from 'src/stores/AgentProfileStore/AgentProfileStore';
import styled from 'styled-components';

const store = AgentProfileStore;

export const AgentProfilePage = observer(() => {
    return (
        <StyledEntityPresentationProfile
            store={store}
            entityName="agentProfile"
        />
    );
});

const StyledEntityPresentationProfile = styled(EntityPresentationProfile)`
    .formio-component-htmlelement {
        h2 {
            padding: 0;
        }
    }
    .ant-layout-content {
        min-height: 100vh;
    }
`;
